<template>
  <div id="hrms13x-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM81X3']['10'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <hrms-table :columns="tab2Table" :data="data" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms13x-detail-tab2',
  props: [ 'labels', 'data', 'tab2Table' ]
}
</script>


// WEBPACK FOOTER //
// detailTab2.vue?e59121ec